//provincias Ecuador
export const ecuadorProvinces = [
    { value: "azuay", label: "Azuay" },
    { value: "bolivar", label: "Bolívar" },
    { value: "canar", label: "Cañar" },
    { value: "carchi", label: "Carchi" },
    { value: "chimborazo", label: "Chimborazo" },
    { value: "cotopaxi", label: "Cotopaxi" },
    { value: "el-oro", label: "El Oro" },
    { value: "esmeraldas", label: "Esmeraldas" },
    { value: "galapagos", label: "Galápagos" },
    { value: "guayas", label: "Guayas" },
    { value: "imbabura", label: "Imbabura" },
    { value: "loja", label: "Loja" },
    { value: "los-rios", label: "Los Ríos" },
    { value: "manabi", label: "Manabí" },
    { value: "morona-santiago", label: "Morona Santiago" },
    { value: "napo", label: "Napo" },
    { value: "orellana", label: "Orellana" },
    { value: "pastaza", label: "Pastaza" },
    { value: "pichincha", label: "Pichincha" },
    { value: "santa-elena", label: "Santa Elena" },
    { value: "santo-domingo", label: "Santo Domingo de los Tsáchilas" },
    { value: "sucumbios", label: "Sucumbíos" },
    { value: "tungurahua", label: "Tungurahua" },
    { value: "zamora-chinchipe", label: "Zamora Chinchipe" }
];

// Ciudades de Ecuador
export const ecuadorCities = [
    // Azuay
    { value: "cuenca", label: "Cuenca", province: "Azuay" },
    { value: "giron", label: "Girón", province: "Azuay" },
    { value: "gualaceo", label: "Gualaceo", province: "Azuay" },
    { value: "paute", label: "Paute", province: "Azuay" },

    // Bolívar
    { value: "guaranda", label: "Guaranda", province: "Bolívar" },
    { value: "san-miguel", label: "San Miguel", province: "Bolívar" },

    // Cañar
    { value: "azogues", label: "Azogues", province: "Cañar" },
    { value: "canar", label: "Cañar", province: "Cañar" },
    { value: "la-troncal", label: "La Troncal", province: "Cañar" },

    // Carchi
    { value: "tulcan", label: "Tulcán", province: "Carchi" },
    { value: "san-gabriel", label: "San Gabriel", province: "Carchi" },

    // Chimborazo
    { value: "riobamba", label: "Riobamba", province: "Chimborazo" },
    { value: "alausi", label: "Alausí", province: "Chimborazo" },
    { value: "guano", label: "Guano", province: "Chimborazo" },

    // Cotopaxi
    { value: "latacunga", label: "Latacunga", province: "Cotopaxi" },
    { value: "pujili", label: "Pujilí", province: "Cotopaxi" },
    { value: "salcedo", label: "Salcedo", province: "Cotopaxi" },

    // El Oro
    { value: "machala", label: "Machala", province: "El Oro" },
    { value: "huaquillas", label: "Huaquillas", province: "El Oro" },
    { value: "pasaje", label: "Pasaje", province: "El Oro" },
    { value: "santa-rosa", label: "Santa Rosa", province: "El Oro" },

    // Esmeraldas
    { value: "esmeraldas", label: "Esmeraldas", province: "Esmeraldas" },
    { value: "atacames", label: "Atacames", province: "Esmeraldas" },
    { value: "muisne", label: "Muisne", province: "Esmeraldas" },

    // Galápagos
    { value: "puerto-baquerizo-moreno", label: "Puerto Baquerizo Moreno", province: "Galápagos" },
    { value: "puerto-ayora", label: "Puerto Ayora", province: "Galápagos" },
    { value: "puerto-villamil", label: "Puerto Villamil", province: "Galápagos" },

    // Guayas
    { value: "guayaquil", label: "Guayaquil", province: "Guayas" },
    { value: "duran", label: "Durán", province: "Guayas" },
    { value: "milagro", label: "Milagro", province: "Guayas" },
    { value: "daule", label: "Daule", province: "Guayas" },
    { value: "samborondon", label: "Samborondón", province: "Guayas" },
    { value: "playas", label: "Playas", province: "Guayas" },
    { value: "naranjal", label: "Naranjal", province: "Guayas" },

    // Imbabura
    { value: "ibarra", label: "Ibarra", province: "Imbabura" },
    { value: "otavalo", label: "Otavalo", province: "Imbabura" },
    { value: "cotacachi", label: "Cotacachi", province: "Imbabura" },
    { value: "atuntaqui", label: "Atuntaqui", province: "Imbabura" },

    // Loja
    { value: "loja", label: "Loja", province: "Loja" },
    { value: "catamayo", label: "Catamayo", province: "Loja" },
    { value: "cariamanga", label: "Cariamanga", province: "Loja" },
    { value: "macara", label: "Macará", province: "Loja" },

    // Los Ríos
    { value: "babahoyo", label: "Babahoyo", province: "Los Ríos" },
    { value: "quevedo", label: "Quevedo", province: "Los Ríos" },
    { value: "ventanas", label: "Ventanas", province: "Los Ríos" },
    { value: "vinces", label: "Vinces", province: "Los Ríos" },

    // Manabí
    { value: "portoviejo", label: "Portoviejo", province: "Manabí" },
    { value: "manta", label: "Manta", province: "Manabí" },
    { value: "chone", label: "Chone", province: "Manabí" },
    { value: "bahia-de-caraquez", label: "Bahía de Caráquez", province: "Manabí" },
    { value: "jipijapa", label: "Jipijapa", province: "Manabí" },
    { value: "montecristi", label: "Montecristi", province: "Manabí" },

    // Morona Santiago
    { value: "macas", label: "Macas", province: "Morona Santiago" },
    { value: "sucua", label: "Sucúa", province: "Morona Santiago" },
    { value: "gualaquiza", label: "Gualaquiza", province: "Morona Santiago" },

    // Napo
    { value: "tena", label: "Tena", province: "Napo" },
    { value: "archidona", label: "Archidona", province: "Napo" },
    { value: "el-chaco", label: "El Chaco", province: "Napo" },

    // Orellana
    { value: "puerto-francisco-de-orellana", label: "Puerto Francisco de Orellana (Coca)", province: "Orellana" },
    { value: "la-joya-de-los-sachas", label: "La Joya de los Sachas", province: "Orellana" },

    // Pastaza
    { value: "puyo", label: "Puyo", province: "Pastaza" },
    { value: "shell", label: "Shell", province: "Pastaza" },
    { value: "mera", label: "Mera", province: "Pastaza" },

    // Pichincha
    { value: "quito", label: "Quito", province: "Pichincha" },
    { value: "cayambe", label: "Cayambe", province: "Pichincha" },
    { value: "machachi", label: "Machachi", province: "Pichincha" },
    { value: "sangolqui", label: "Sangolquí", province: "Pichincha" },
    { value: "tabacundo", label: "Tabacundo", province: "Pichincha" },
    { value: "pedro-vicente-maldonado", label: "Pedro Vicente Maldonado", province: "Pichincha" },

    // Santa Elena
    { value: "santa-elena", label: "Santa Elena", province: "Santa Elena" },
    { value: "salinas", label: "Salinas", province: "Santa Elena" },
    { value: "la-libertad", label: "La Libertad", province: "Santa Elena" },

    // Santo Domingo
    { value: "santo-domingo", label: "Santo Domingo", province: "Santo Domingo de los Tsáchilas" },

    // Sucumbíos
    { value: "nueva-loja", label: "Nueva Loja (Lago Agrio)", province: "Sucumbíos" },
    { value: "shushufindi", label: "Shushufindi", province: "Sucumbíos" },
    { value: "gonzalo-pizarro", label: "Gonzalo Pizarro", province: "Sucumbíos" },

    // Tungurahua
    { value: "ambato", label: "Ambato", province: "Tungurahua" },
    { value: "banos", label: "Baños de Agua Santa", province: "Tungurahua" },
    { value: "pelileo", label: "Pelileo", province: "Tungurahua" },
    { value: "pillaro", label: "Píllaro", province: "Tungurahua" },

    // Zamora Chinchipe
    { value: "zamora", label: "Zamora", province: "Zamora Chinchipe" },
    { value: "yantzaza", label: "Yantzaza", province: "Zamora Chinchipe" },
    { value: "zumba", label: "Zumba", province: "Zamora Chinchipe" }
];

//paises
export const countries = [
    { value: "af", label: "Afganistán" },
    { value: "al", label: "Albania" },
    { value: "de", label: "Alemania" },
    { value: "ad", label: "Andorra" },
    { value: "ao", label: "Angola" },
    { value: "ag", label: "Antigua y Barbuda" },
    { value: "sa", label: "Arabia Saudita" },
    { value: "dz", label: "Argelia" },
    { value: "ar", label: "Argentina" },
    { value: "am", label: "Armenia" },
    { value: "au", label: "Australia" },
    { value: "at", label: "Austria" },
    { value: "az", label: "Azerbaiyán" },
    { value: "bs", label: "Bahamas" },
    { value: "bd", label: "Bangladés" },
    { value: "bb", label: "Barbados" },
    { value: "bh", label: "Baréin" },
    { value: "be", label: "Bélgica" },
    { value: "bz", label: "Belice" },
    { value: "bj", label: "Benín" },
    { value: "by", label: "Bielorrusia" },
    { value: "bo", label: "Bolivia" },
    { value: "ba", label: "Bosnia y Herzegovina" },
    { value: "bw", label: "Botsuana" },
    { value: "br", label: "Brasil" },
    { value: "bn", label: "Brunéi" },
    { value: "bg", label: "Bulgaria" },
    { value: "bf", label: "Burkina Faso" },
    { value: "bi", label: "Burundi" },
    { value: "bt", label: "Bután" },
    { value: "cv", label: "Cabo Verde" },
    { value: "kh", label: "Camboya" },
    { value: "cm", label: "Camerún" },
    { value: "ca", label: "Canadá" },
    { value: "qa", label: "Catar" },
    { value: "td", label: "Chad" },
    { value: "cl", label: "Chile" },
    { value: "cn", label: "China" },
    { value: "cy", label: "Chipre" },
    { value: "co", label: "Colombia" },
    { value: "km", label: "Comoras" },
    { value: "cg", label: "Congo" },
    { value: "kp", label: "Corea del Norte" },
    { value: "kr", label: "Corea del Sur" },
    { value: "ci", label: "Costa de Marfil" },
    { value: "cr", label: "Costa Rica" },
    { value: "hr", label: "Croacia" },
    { value: "cu", label: "Cuba" },
    { value: "dk", label: "Dinamarca" },
    { value: "dm", label: "Dominica" },
    { value: "eg", label: "Egipto" },
    { value: "sv", label: "El Salvador" },
    { value: "ae", label: "Emiratos Árabes Unidos" },
    { value: "er", label: "Eritrea" },
    { value: "sk", label: "Eslovaquia" },
    { value: "si", label: "Eslovenia" },
    { value: "es", label: "España" },
    { value: "us", label: "Estados Unidos" },
    { value: "ee", label: "Estonia" },
    { value: "sz", label: "Esuatini" },
    { value: "et", label: "Etiopía" },
    { value: "ph", label: "Filipinas" },
    { value: "fi", label: "Finlandia" },
    { value: "fj", label: "Fiyi" },
    { value: "fr", label: "Francia" },
    { value: "ga", label: "Gabón" },
    { value: "gm", label: "Gambia" },
    { value: "ge", label: "Georgia" },
    { value: "gh", label: "Ghana" },
    { value: "gr", label: "Grecia" },
    { value: "gd", label: "Granada" },
    { value: "gt", label: "Guatemala" },
    { value: "gn", label: "Guinea" },
    { value: "gq", label: "Guinea Ecuatorial" },
    { value: "gw", label: "Guinea-Bisáu" },
    { value: "gy", label: "Guyana" },
    { value: "ht", label: "Haití" },
    { value: "hn", label: "Honduras" },
    { value: "hu", label: "Hungría" },
    { value: "in", label: "India" },
    { value: "id", label: "Indonesia" },
    { value: "iq", label: "Irak" },
    { value: "ir", label: "Irán" },
    { value: "ie", label: "Irlanda" },
    { value: "is", label: "Islandia" },
    { value: "il", label: "Israel" },
    { value: "it", label: "Italia" },
    { value: "jm", label: "Jamaica" },
    { value: "jp", label: "Japón" },
    { value: "jo", label: "Jordania" },
    { value: "kz", label: "Kazajistán" },
    { value: "ke", label: "Kenia" },
    { value: "kg", label: "Kirguistán" },
    { value: "ki", label: "Kiribati" },
    { value: "kw", label: "Kuwait" },
    { value: "la", label: "Laos" },
    { value: "ls", label: "Lesoto" },
    { value: "lv", label: "Letonia" },
    { value: "lb", label: "Líbano" },
    { value: "lr", label: "Liberia" },
    { value: "ly", label: "Libia" },
    { value: "li", label: "Liechtenstein" },
    { value: "lt", label: "Lituania" },
    { value: "lu", label: "Luxemburgo" },
    { value: "mg", label: "Madagascar" },
    { value: "my", label: "Malasia" },
    { value: "mw", label: "Malaui" },
    { value: "mv", label: "Maldivas" },
    { value: "ml", label: "Mali" },
    { value: "mt", label: "Malta" },
    { value: "ma", label: "Marruecos" },
    { value: "mh", label: "Islas Marshall" },
    { value: "mu", label: "Mauricio" },
    { value: "mr", label: "Mauritania" },
    { value: "mx", label: "México" },
    { value: "fm", label: "Micronesia" },
    { value: "md", label: "Moldavia" },
    { value: "mc", label: "Mónaco" },
    { value: "mn", label: "Mongolia" },
    { value: "me", label: "Montenegro" },
    { value: "mz", label: "Mozambique" },
    { value: "mm", label: "Myanmar" },
    { value: "na", label: "Namibia" },
    { value: "nr", label: "Nauru" },
    { value: "np", label: "Nepal" },
    { value: "ni", label: "Nicaragua" },
    { value: "ne", label: "Níger" },
    { value: "ng", label: "Nigeria" },
    { value: "no", label: "Noruega" },
    { value: "nz", label: "Nueva Zelanda" },
    { value: "om", label: "Omán" },
    { value: "nl", label: "Países Bajos" },
    { value: "pk", label: "Pakistán" },
    { value: "pw", label: "Palaos" },
    { value: "pa", label: "Panamá" },
    { value: "pg", label: "Papúa Nueva Guinea" },
    { value: "py", label: "Paraguay" },
    { value: "pe", label: "Perú" },
    { value: "pl", label: "Polonia" },
    { value: "pt", label: "Portugal" },
    { value: "gb", label: "Reino Unido" },
    { value: "cf", label: "República Centroafricana" },
    { value: "cz", label: "República Checa" },
    { value: "cd", label: "República Democrática del Congo" },
    { value: "do", label: "República Dominicana" },
    { value: "rw", label: "Ruanda" },
    { value: "ro", label: "Rumania" },
    { value: "ru", label: "Rusia" },
    { value: "ws", label: "Samoa" },
    { value: "kn", label: "San Cristóbal y Nieves" },
    { value: "sm", label: "San Marino" },
    { value: "vc", label: "San Vicente y las Granadinas" },
    { value: "lc", label: "Santa Lucía" },
    { value: "st", label: "Santo Tomé y Príncipe" },
    { value: "sn", label: "Senegal" },
    { value: "rs", label: "Serbia" },
    { value: "sc", label: "Seychelles" },
    { value: "sl", label: "Sierra Leona" },
    { value: "sg", label: "Singapur" },
    { value: "sy", label: "Siria" },
    { value: "so", label: "Somalia" },
    { value: "lk", label: "Sri Lanka" },
    { value: "za", label: "Sudáfrica" },
    { value: "sd", label: "Sudán" },
    { value: "ss", label: "Sudán del Sur" },
    { value: "se", label: "Suecia" },
    { value: "ch", label: "Suiza" },
    { value: "sr", label: "Surinam" },
    { value: "th", label: "Tailandia" },
    { value: "tz", label: "Tanzania" },
    { value: "tj", label: "Tayikistán" },
    { value: "tl", label: "Timor Oriental" },
    { value: "tg", label: "Togo" },
    { value: "to", label: "Tonga" },
    { value: "tt", label: "Trinidad y Tobago" },
    { value: "tn", label: "Túnez" },
    { value: "tm", label: "Turkmenistán" },
    { value: "tr", label: "Turquía" },
    { value: "tv", label: "Tuvalu" },
    { value: "ua", label: "Ucrania" },
    { value: "ug", label: "Uganda" },
    { value: "uy", label: "Uruguay" },
    { value: "uz", label: "Uzbekistán" },
    { value: "vu", label: "Vanuatu" },
    { value: "va", label: "Vaticano" },
    { value: "ve", label: "Venezuela" },
    { value: "vn", label: "Vietnam" },
    { value: "ye", label: "Yemen" },
    { value: "dj", label: "Yibuti" },
    { value: "zm", label: "Zambia" },
    { value: "zw", label: "Zimbabue" }
];